import { Directive, HostBinding, HostListener, Output, EventEmitter } from '@angular/core';
import { RxUploadService } from '../rx-upload.service';
import { SnackbarService } from '@nrwl/snackbar-services';

@Directive({
  selector: '[RxUploadZone]',
})
export class RxUploadZoneDirective {
  @Output() files = new EventEmitter<any>();
  @Output() droppedFiles = new EventEmitter<any>();

  @HostBinding('style.background') private background = '#eee';

  @HostListener('dragover', ['$event']) public onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#999';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#eee';
  }

  @HostListener('drop', ['$event']) public onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const files = [...evt.dataTransfer.files];
    const arr = <any>[];

    files.map((media: any) => {
      if (this.isMedia(media)) {
        arr.push(media);
      }
    });

    if (files.length > 0) {
      this.background = '#eee';
    }

    if (arr.length > 0) {
      this.droppedFiles.emit(arr);
      this.files.emit(this.service.transform(arr));
    }
  }

  constructor(
    private service: RxUploadService,
    private snackbarService: SnackbarService,
  ) {}

  isMedia(file) {
    if (file.type.match('image.*') || file.type.match('video.*')) {
      return true;
    } else {
      this.snackbarService.warning(`File "${file.name}" incorrect format only image/video`);
      return false;
    }
  }
}
